import React, { useState } from "react";
import axios from "axios";
import { getEnvVars } from "../../Utils/env-utils";
import { useHistory } from "react-router-dom";
import BasicInformation from "./BasicInformation";
import { useLoadingSpinner } from "../common/LoadingSpinner/LoadingSpinner";

var theEnv = getEnvVars(window.location.hostname);

const { apiUrl } = getEnvVars(window.location.hostname);

const BasicInformationController = () => {
  const history = useHistory();
  const [formSubmitError, setFormSubmitError] = useState(null);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [isMessageSending, setIsMessageSending] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [alertText, setAlertText] = useState("Success!");
  const [waiting, setWaiting] = useState(false);
  const [errorFindingPatient, setErrorFindingPatient] = useState(false);
  const [errorAddingCreditCard, setErrorAddingCreditCard] = useState(false);
  const [LoadingSpinner, setSpinner] = useLoadingSpinner();
  const [creditMoreCardsMessage, setCreditMoreCardsMessage] = useState([]);

  const handleSubmitPatientLookupForm = (newClaimRequest) => {
    setIsMessageSending(true);
    setFormSubmitError(null);
    setWaiting(true);
    setSpinner(true);
    setErrorFindingPatient(false);
    setErrorAddingCreditCard(false);
    // axios.post(theEnv.REACT_APP_NEW_PATIENT_LOOKUP_API_URI, newClaimRequest, {
    axios
      .post(`${apiUrl}/patient/searchPatient`, newClaimRequest, {
        headers: {
          apikey: theEnv.REACT_APP_API_KEY_URI,
        },
      })
      .then(({ data }) => {
        window.sessionStorage.setItem(
          "sessionToken",
          JSON.stringify(data.sessionToken)
        );
        console.log(JSON.parse(window.sessionStorage.getItem("sessionToken")));
        if (data.existingCCStatus === "no") {
          // debugger;
          history.push({
            pathname: `/ccdoesnotexist`,
            isRedirect: true,
            data: { ...data },
            state: { firstName: newClaimRequest.firstName },
          });
        } else if (data.existingCCStatus === "yes") {
          history.push({
            pathname: `/ccdoesnotexist`,
            isRedirect: true,
            data: { ...data },
            state: { firstName: newClaimRequest.firstName },
          });
        } else if (data.existingCCStatus) {
          setErrorAddingCreditCard(true);
          let existingCCStatusRes = data.existingCCStatus;
          setCreditMoreCardsMessage(existingCCStatusRes);
        } else if (data.status === "204") {
          setErrorFindingPatient(true);
        }
      })
      .catch((e) => {
        if (e.response && e.response.status === 400) {
          console.log(e.response.data); // Handle 400 Bad Request error
          if ("message" in e.response.data) {
            if (
              e.response.data.message ===
              "Multiple patient records found for the search criteria, please contact the customer support 833-Meds-ARx for more help."
            ) {
              console.log("*** Message Is Validate *****");
              setCreditMoreCardsMessage([
                "We require additional information to make an accurate account match.  Please call 1-833-Meds-ARx.",
              ]);
              setErrorAddingCreditCard(true);
            } else {
              setErrorFindingPatient(true);
            }
          } else {
            setErrorFindingPatient(true);
          }
        } else {
          setErrorFindingPatient(true);
          console.log("An error occurred:", e); // Handle other errors
        }
      })
      .finally(() => {
        setSpinner(false);
        setIsMessageSending(false);
        setWaiting(false);
      });
  };

  return (
    <>
      <LoadingSpinner />
      <BasicInformation
        handleSubmit={handleSubmitPatientLookupForm}
        errorFindingPatient={errorFindingPatient}
        errorAddingCreditCard={errorAddingCreditCard}
        existingCCStatusRes={creditMoreCardsMessage}
        isWaiting={waiting}
      />
    </>
  );
};

export default BasicInformationController;
